import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import * as styles from "./index.module.scss";

const ImageWrapper = styled.img`
  width: 70%;
  margin: 0 auto;
`;

const TextWithTitle = ({ title, text, image = null }) => {
  return (
    <div className={styles.wrapper}>
      {image && <ImageWrapper src={image} alt={title} />}
      <span className={styles.title}>{title}</span>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

TextWithTitle.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.string,
};

export default TextWithTitle;
